export default __webpack_public_path__ + "static/media/T-Shirt.7ab27f01.png";